import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';
import Text from '../Text';

const commonClasses =
  'block p-4 lg:px-8 w-full text-left transition bg-white text-blue \
  betterhover:hover:bg-grey-800 \
  betterhover:hover:text-white';

const focusClasses =
  'focus:outline-none focus-visible:outline-offset-4 \
  focus-visible:outline-4 focus-visible:outline-focus';

const activeClasses = 'active:translate-y-1';

type KnowledgeHubButtonProps = PropsWithChildren<{
  id?: string;
  onClick: () => void;
  selected?: boolean;
}>;

const KnowledgeHubButton: FC<KnowledgeHubButtonProps> = ({
  children,
  onClick,
  selected,
  id,
}) => {
  const classes = classNames(
    commonClasses,
    focusClasses,
    activeClasses,
    selected && '!bg-blue !text-white',
  );

  return (
    <button onClick={onClick} className={classes} id={id}>
      <Text bold size="preamble" color="inherit">
        {children}
      </Text>
    </button>
  );
};

export default KnowledgeHubButton;
